const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/notifications/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18n from '@/lib/translations/i18n';
import type { LoaderData } from '@/lib/types/common';
export const Route = createFileRoute('/(app)/org/$org/settings/notifications/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: (): LoaderData => ({
    crumb: i18n.t('common.settings.notifications.notifications')
  }),
  staticData: {
    topNav: {
      title: i18n.t('common.settings.notifications.notifications')
    }
  }
});